/** Native homepage layout and swipeable carousel, independent of page builders. */
class KrHomeLayout extends HTMLElement {
  #controller;
  connectedCallback() {
    const template = this.querySelector('template[shadowrootmode]');
    if (!this.shadowRoot && template) {
      this.attachShadow({ mode: 'open' }).append(template.content);
      template.remove();
    }
    if (!this.shadowRoot) return;
    this.#controller?.abort();
    this.#controller = new AbortController();
    const root = this.shadowRoot;
    const slider = root.querySelector('[data-home-carousel]');
    if (!slider) return;
    const slides = [...slider.children];
    const previous = root.querySelector('[data-carousel-prev="action-slider"]');
    const next = root.querySelector('[data-carousel-next="action-slider"]');
    const move = (direction) => slider.scrollBy({left:slider.clientWidth * direction, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previous?.addEventListener('click', () => move(-1), {signal:this.#controller.signal});
    next?.addEventListener('click', () => move(1), {signal:this.#controller.signal});
    const update = () => {
      if (previous) previous.disabled = slider.scrollLeft <= 2;
      if (next) next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;
    };
    slider.addEventListener('scroll', update, {passive:true,signal:this.#controller.signal});
    slider.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    }, {signal:this.#controller.signal});
    slides.forEach((slide,index) => { slide.setAttribute('role','group'); slide.setAttribute('aria-label',`${index+1} / ${slides.length}`); });
    update();
  }
  disconnectedCallback() { this.#controller?.abort(); }
}
if (!customElements.get('kr-home-layout')) customElements.define('kr-home-layout', KrHomeLayout);
